import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
  Divider,
} from "@mui/material";
import {
  Login as LoginIcon,
  Dashboard as DashboardIcon,
} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { NavBar } from "./NavBar";
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

export const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { isAuthenticated } = useContext(AuthContext);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogoClick = () => {
    navigate("/home");
  };

  const handleAuthAction = () => {
    if (isAuthenticated) {
      navigate("/dashboard");
    } else {
      navigate("/secretaria-login");
    }
  };

  const menuItems = [
    { label: "INÍCIO", route: "/home" },
    { label: "SOBRE NÓS", route: "/sobre" },
    { label: "MINISTRAÇÕES", route: "/ministracoes" },
    { label: "EVENTOS", route: "/eventos" },
    { label: "INSCRIÇÕES", route: "/inscricoes" },
    {
      label: "VERBO SHOP",
      route: () => window.open("https://verboshop.com.br/", "_blank"),
    },
    {
      label: "CADASTRO DE MEMBROS",
      route: () => window.open("https://verbo.link/membroszonasulcg", "_blank"),
    },
    { label: "CONTATO", route: "/contato" },
  ];

  const handleMobileMenuClick = (route) => {
    navigate(route);
    if (typeof route === "function") {
      route();
    } else {
      navigate(route);
    }
    setMobileOpen(false);
  };

  const drawer = (
    <Box sx={{ backgroundColor: "primary.main", height: "100%", color: "background.default" }}>
      <List>
        {menuItems.map((item) => (
          <ListItem
            button
            key={item.label}
            onClick={() => handleMobileMenuClick(item.route)}
          >
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
        <Divider sx={{ borderColor: "background.default", my: 1 }} />
        <ListItem button onClick={handleAuthAction}>
          {isAuthenticated ? (
            <>
              <DashboardIcon sx={{ color: "background.default", mr: 1 }} />
              <ListItemText primary="DASHBOARD" />
            </>
          ) : (
            <>
              <LoginIcon sx={{ color: "background.default", mr: 1 }} />
              <ListItemText primary="LOGIN" />
            </>
          )}
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="sticky" sx={{ backgroundColor: "primary.main" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* Logo */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={handleLogoClick}
          >
            <img
              src="https://verbodavidacaxias.com.br/assets/verbovidacaxiassul/images/logo-placeholder.webp"
              alt="Logo"
              style={{
                height: isMobile ? "30px" : "40px",
                maxWidth: isMobile ? "150px" : "200px",
                objectFit: "contain",
              }}
            />
          </Box>

          {/* Desktop Navigation */}
          {!isMobile && (
            <>
              <Box
                sx={{ display: "flex", justifyContent: "center", flexGrow: 1 }}
              >
                <NavBar />
              </Box>
              <Button
                sx={{
                  color: "background.default",
                  textTransform: "none",
                  fontSize: "0.85rem",
                  padding: "4px 12px",
                  minWidth: "auto",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.1)",
                  },
                }}
                startIcon={isAuthenticated ? <DashboardIcon /> : <LoginIcon />}
                onClick={handleAuthAction}
              >
                {isAuthenticated ? "Dashboard" : "Login"}
              </Button>
            </>
          )}

          {/* Mobile Menu Button */}
          {isMobile && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },
        }}
      >
        {drawer}
      </Drawer>
    </Box>
  );
};
